// extracted by mini-css-extract-plugin
export default {"tx":"c40ac90fef","line":"_5d501dc27f"};